<template>
    <div>
        <div class="d-flex gap-4">
            <a
                v-if="impressumLink"
                :href="impressumLink"
                target="_blank"
                class="font-weight-bold text-body text-sm">Impressum</a>
            <a
                v-if="privacyLink"
                :href="privacyLink"
                target="_blank"
                class="font-weight-bold text-body text-sm">Datenschutz</a>
        </div>
        <!--        <Modal-->
        <!--            v-model:show="impressumOpen"-->
        <!--            size="lg">-->
        <!--            <template #header>-->
        <!--                <h2>Impressum</h2>-->
        <!--            </template>-->
        <!--            <template #default>-->
        <!--                <h3>Herausgeber</h3>-->

        <!--                <p>-->
        <!--                    Evangelisches Jugendwerk in Württemberg<br>-->
        <!--                    Haeberlinstraße 1-3<br>-->
        <!--                    D-70563 Stuttgart<br>-->
        <!--                </p>-->
        <!--                <p>-->
        <!--                    Telefon: 07 11/97 81-0<br>-->
        <!--                    Telefax: 07 11/97 81-30<br>-->
        <!--                    E-Mail:-->
        <!--                    <a href="mailto:info@ejwue.de">-->
        <!--                        info@ejwue.de-->
        <!--                    </a><br>-->
        <!--                    Internet: <a href="http://www.ejwue.de">http://www.ejwue.de</a>-->
        <!--                </p>-->
        <!--                <h3>Inhaber</h3>-->
        <!--                <p>-->
        <!--                    Das Evangelische Jugendwerk in Württemberg ist eine rechtlich unselbständige Einrichtung der-->
        <!--                    Evangelischen Landeskirche in Württemberg, Körperschaft des öffentlichen Rechts-->
        <!--                </p>-->
        <!--                <p>-->
        <!--                    Steuer-Nummer EJW: 99153/00033-->
        <!--                </p>-->
        <!--                <p>-->
        <!--                    USt-IdNr. EJW: DE147793714-->
        <!--                </p>-->
        <!--                <p>-->
        <!--                    Vertretungsberechtigter Geschäftsführer:<br>-->
        <!--                    Friedemann Berner-->
        <!--                </p>-->
        <!--            </template>-->
        <!--        </Modal>-->
        <!--        <Modal-->
        <!--            v-model:show="datenschutzOpen"-->
        <!--            size="lg">-->
        <!--            <template #header>-->
        <!--                <h2>Datenschutz</h2>-->
        <!--            </template>-->
        <!--            <template #default>-->
        <!--                <h3>Geltungsbereich</h3>-->
        <!--                <p>-->
        <!--                    Diese Datenschutzerklärung klärt Nutzer über die Art, den Umfang und Zwecke der Erhebung und-->
        <!--                    Verwendung personenbezogener Daten durch den verantwortlichen Anbieter auf dieser Website (im-->
        <!--                    folgenden “Angebot”) auf.-->
        <!--                </p>-->

        <!--                <p>-->
        <!--                    Die rechtlichen Grundlagen des Datenschutzes finden sich im Bundesdatenschutzgesetz (BDSG) und dem-->
        <!--                    Telemediengesetz (TMG).-->
        <!--                </p>-->

        <!--                <h3>Zugriffsdaten/ Server-Logfiles</h3>-->

        <!--                <p>-->
        <!--                    Der Anbieter (beziehungsweise sein Webspace-Provider) erhebt Daten über jeden Zugriff auf das-->
        <!--                    Angebot-->
        <!--                    (so genannte Serverlogfiles). Zu den Zugriffsdaten gehören:-->
        <!--                </p>-->

        <!--                <p>-->
        <!--                    Name der abgerufenen Webseite, Datei, Datum und Uhrzeit des Abrufs, übertragene Datenmenge, Meldung-->
        <!--                    über-->
        <!--                    erfolgreichen Abruf, Browsertyp nebst Version, das Betriebssystem des Nutzers, Referrer URL (die-->
        <!--                    zuvor-->
        <!--                    besuchte Seite), IP-Adresse und der anfragende Provider.-->
        <!--                </p>-->

        <!--                <p>-->
        <!--                    Der Anbieter verwendet die Protokolldaten nur für statistische Auswertungen zum Zweck des Betriebs,-->
        <!--                    der-->
        <!--                    Sicherheit und der Optimierung des Angebotes. Der Anbieterbehält sich jedoch vor, die Protokolldaten-->
        <!--                    nachträglich zu überprüfen, wenn aufgrund konkreter Anhaltspunkte der berechtigte Verdacht einer-->
        <!--                    rechtswidrigen Nutzung besteht.-->
        <!--                </p>-->

        <!--                <h3>Umgang mit personenbezogenen Daten</h3>-->
        <!--                <p>-->
        <!--                    Personenbezogene Daten sind Informationen, mit deren Hilfe eine Person bestimmbar ist, also Angaben,-->
        <!--                    die-->
        <!--                    zurück zu einer Person verfolgt werden können. Dazu gehören der Name, die Emailadresse oder die-->
        <!--                    Telefonnummer. Aber auch Daten über Vorlieben, Hobbies, Mitgliedschaften oder welche Webseiten von-->
        <!--                    jemandem angesehen wurden zählen zu personenbezogenen Daten.-->
        <!--                </p>-->

        <!--                <p>-->
        <!--                    Personenbezogene Daten werden von dem Anbieter nur dann erhoben, genutzt und weiter gegeben, wenn-->
        <!--                    dies-->
        <!--                    gesetzlich erlaubt ist oder die Nutzer in die Datenerhebung einwilligen.-->
        <!--                </p>-->

        <!--                <h3>Kontaktaufnahme</h3>-->
        <!--                <p>-->
        <!--                    Bei der Kontaktaufnahme mit dem Anbieter (zum Beispiel per Kontaktformular oder E-Mail) werden die-->
        <!--                    Angaben des Nutzers zwecks Bearbeitung der Anfrage sowie für den Fall, dass Anschlussfragen-->
        <!--                    entstehen,-->
        <!--                    gespeichert.-->
        <!--                </p>-->

        <!--                <h3>Kommentare und Beiträge</h3>-->
        <!--                <p>-->
        <!--                    Wenn Nutzer Kommentare im Blog oder sonstige Beiträge hinterlassen, werden ihre IP-Adressen-->
        <!--                    gespeichert.-->
        <!--                    Das erfolgt zur Sicherheit des Anbieters, falls jemand in Kommentaren und Beiträgen widerrechtliche-->
        <!--                    Inhalte schreibt (Beleidigungen, verbotene politische Propaganda, etc.). In diesem Fall kann der-->
        <!--                    Anbieter selbst für den Kommentar oder Beitrag belangt werden und ist daher an der Identität des-->
        <!--                    Verfassers interessiert.-->
        <!--                </p>-->
        <!--                <h3>Einbindung von Diensten und Inhalten Dritter</h3>-->
        <!--                <p>-->
        <!--                    Es kann vorkommen, dass innerhalb dieses Onlineangebotes Inhalte Dritter, wie zum Beispiel Videos-->
        <!--                    von-->
        <!--                    YouTube, Kartenmaterial von Google-Maps, RSS-Feeds oder Grafiken von anderen Webseiten eingebunden-->
        <!--                    werden. Dies setzt immer voraus, dass die Anbieter dieser Inhalte (nachfolgend bezeichnet als-->
        <!--                    "Dritt-Anbieter") die IP-Adresse der Nutzer wahr nehmen. Denn ohne die IP-Adresse, könnten sie die-->
        <!--                    Inhalte nicht an den Browser des jeweiligen Nutzers senden. Die IP-Adresse ist damit für die-->
        <!--                    Darstellung-->
        <!--                    dieser Inhalte erforderlich. Wir bemühen uns nur solche Inhalte zu verwenden, deren jeweilige-->
        <!--                    Anbieter-->
        <!--                    die IP-Adresse lediglich zur Auslieferung der Inhalte verwenden. Jedoch haben wir keinen Einfluss-->
        <!--                    darauf, falls die Dritt-Anbieter die IP-Adresse z.B. für statistische Zwecke speichern. Soweit dies-->
        <!--                    uns-->
        <!--                    bekannt ist, klären wir die Nutzer darüber auf.-->
        <!--                </p>-->
        <!--                <h3>Cookies</h3>-->
        <!--                <p>-->
        <!--                    Cookies sind kleine Dateien, die es ermöglichen, auf dem Zugriffsgerät der Nutzer (PC, Smartphone-->
        <!--                    o.ä.)-->
        <!--                    spezifische, auf das Gerät bezogene Informationen zu speichern. Sie dienen zum einem der-->
        <!--                    Benutzerfreundlichkeit von Webseiten und damit den Nutzern (z.B. Speicherung von Logindaten). Zum-->
        <!--                    anderen dienen sie, um die statistische Daten der Webseitennutzung zu erfassen und sie zwecks-->
        <!--                    Verbesserung des Angebotes analysieren zu können. Die Nutzer können auf den Einsatz der Cookies-->
        <!--                    Einfluss-->
        <!--                    nehmen. Die meisten Browser verfügen eine Option mit der das Speichern von Cookies eingeschränkt-->
        <!--                    oder-->
        <!--                    komplett verhindert wird. Allerdings wird darauf hingewiesen, dass die Nutzung und insbesondere der-->
        <!--                    Nutzungskomfort ohne Cookies eingeschränkt werden.-->
        <!--                </p>-->
        <!--                <p>-->
        <!--                    Sie können viele Online-Anzeigen-Cookies von Unternehmen über die US-amerikanische Seite-->
        <!--                    <a-->
        <!--                        href="http://www.aboutads.info/choices/"-->
        <!--                        target="_blank"-->
        <!--                        class="externalLink">www.aboutads.info/choices/</a>-->
        <!--                    oder die EU-Seite <a-->
        <!--                        href="http://www.youronlinechoices.com/uk/your-ad-choices/"-->
        <!--                        target="_blank"-->
        <!--                        class="externalLink">www.youronlinechoices.com/uk/your-ad-choices/</a>-->
        <!--                    verwalten.-->
        <!--                </p>-->
        <!--                <h3>Widerruf, Änderungen, Berichtigungen und Aktualisierungen</h3>-->
        <!--                <p>-->
        <!--                    Der Nutzer hat das Recht, auf Antrag unentgeltlich Auskunft zu erhalten über die personenbezogenen-->
        <!--                    Daten, die über ihn gespeichert wurden. Zusätzlich hat der Nutzer das Recht auf Berichtigung-->
        <!--                    unrichtiger-->
        <!--                    Daten, Sperrung und Löschung seiner personenbezogenen Daten, soweit dem keine gesetzliche-->
        <!--                    Aufbewahrungspflicht entgegensteht.-->
        <!--                </p>-->
        <!--                <p>-->
        <!--                    <a-->
        <!--                        href="http://rechtsanwalt-schwenke.de/smmr-buch/datenschutz-muster-generator-fuer-webseiten-blogs-und-social-media/"-->
        <!--                        target="_blank"-->
        <!--                        class="externalLink">Datenschutz-Muster von Rechtsanwalt Thomas Schwenke - I LAW-->
        <!--                        it</a>-->
        <!--                </p>-->
        <!--                <h3>Nach §36 DSG-EKD wurde als Datenschutzbeauftragter bestellt:</h3>-->
        <!--                <p>-->
        <!--                    Alexander Strobel<br>-->
        <!--                    Evang. Jugendwerk in Württemberg (EJW)<br>-->
        <!--                    Haeberlinstr. 1-3<br>-->
        <!--                    70563 Stuttgart<br>-->
        <!--                    E-Mail: <a href="mailto: datenschutz@ejwue.de">datenschutz@ejwue.de</a>-->
        <!--                </p>-->
        <!--            </template>-->
        <!--        </Modal>-->
    </div>
</template>

<script>
import mainRegistrationMixin from "@/mixins/registration/mainRegistrationMixin";

export default {
    name: "Impressum",
    mixins: [mainRegistrationMixin],
    data() {
        return {
            impressumOpen: false,
            datenschutzOpen: false
        }
    },
    computed: {
        impressumLink() {
            return this.sanitizeLink(this.eventData?.organizerImpressumLink ?? null)
        },
        privacyLink() {
            return this.sanitizeLink(this.eventData?.organizerPrivacyLink ?? null)
        }
    },
    methods: {
        sanitizeLink(link) {
            if(!link) return null
            if(link.startsWith('http')) return link
            return '//' + link
        }
    }
}
</script>

<style scoped>
p {
    font-size: smaller;
    margin-left: .5rem;
}
</style>
